import { useEffect } from 'react';
import {
  createComponentAs,
  createElementAs,
  useEditorRef,
  useElement,
  useElementProps,
  useMediaStore,
  parseMediaUrl,
  ELEMENT_MEDIA_EMBED,
} from '@udecode/plate';
import { Resizable } from './resizable/Resizable';

import './media.scss';

export const useMedia = ({
  pluginKey = ELEMENT_MEDIA_EMBED,
  ...props
}) => {
  const editor = useEditorRef();
  const element = useElement();
  const setUrlData = useMediaStore().set.urlData();
  const { url: elementUrl } = element;

  useEffect(() => {
    const parsed = parseMediaUrl(editor, {
      pluginKey,
      url: elementUrl,
    });

    if (parsed) {
      setUrlData(parsed);
    }
  }, [editor, elementUrl, pluginKey, setUrlData]);

  return useElementProps(props);
};

export const MediaRoot = createComponentAs((props) => {
  const htmlProps = useMedia(props);

  return createElementAs('div', htmlProps);
});

export const Media = {
  Root: MediaRoot,
  Resizable,
};
